import React from 'react'
import HomeScreen from './HomeScreen'

function ShopScreen() {
  return <HomeScreen showHero={false} title="All Products" />
}

export default ShopScreen


